import * as React from "react";
const SvgCollapseTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.48438 3.79956L3.74217 -3.91894e-05L-4.29153e-05 3.79956L7.48438 3.79956Z", fill: "#2851A0" }));
export default SvgCollapseTop;
